import React from "react";

const AproachInfo = () => {
  return (
    <section
  className="bg-fixed bg-gray-200 bg-center bg-cover py-40 px-8 relative"
  style={{
    backgroundImage: `url('/path-to-parallax-background.jpg')`,
  }}
>
  <div className="max-w-7xl mx-auto">
    <div className="grid md:grid-cols-3 gap-12 text-center relative">
      <div className="relative flex flex-col items-center">
        <h1 className="absolute text-8xl font-bold text-gray-300 z-10 top-1/2 transform -translate-y-[10vh]">
          01
        </h1>
        <h2 className="text-xl z-20 font-bold text-[#124E66] mt-4">Think</h2>
        <p className="text-gray-600 z-20 mt-2">We gain practical insights before sharing solutions.</p>
      </div>
      <div className="relative flex flex-col items-center">
        <h1 className="absolute text-8xl font-bold text-gray-300 z-10 top-1/2 transform -translate-y-[10vh]">
          02
        </h1>
        <h2 className="text-xl z-20 font-bold text-[#124E66] mt-4">Create</h2>
        <p className="text-gray-600 z-20 mt-2">We develop strategies rooted in real-world experience.</p>
      </div>
      <div className="relative flex flex-col items-center">
        <h1 className="absolute text-8xl font-bold text-gray-300 z-10 top-1/2 transform -translate-y-[10vh]">
          03
        </h1>
        <h2 className="text-xl z-20 font-bold text-[#124E66] mt-4">Evaluate</h2>
        <p className="text-gray-600 z-20 mt-2">We refine and adapt to achieve lasting success.</p>
      </div>
    </div>
  </div>
</section>

  );
};

export default AproachInfo;
